import gloatApiAuthClient from '@gloat/api-auth-client';

export const WITH_API_HOST = window.location.origin.includes('localhost');
const IS_WITHIN_IFRAME = window.self !== window.top || window.location.search.includes('source=teams');
export const ADMIN_MODE_HEADER_KEY = 'X-Admin-Mode';

const isAdminMode = localStorage.getItem('GLOAT_USER_MODE') === 'admin';

export const apiAuthClient = gloatApiAuthClient({
  withApiHost: WITH_API_HOST,
  onUnauthorizedWhenInIframe: () => {
    const eventInfo = { source: 'gloat-app', type: 'USER_STATUS' };
    window.parent.postMessage({ ...eventInfo, status: 401, message: 'Unauthorized' }, '*');
  },
  isIframe: IS_WITHIN_IFRAME,
  headers: {
    'Content-Type': 'application/json',
    ...(isAdminMode && { [ADMIN_MODE_HEADER_KEY]: 'true' }),
  },
});
